module.exports = __webpack_public_path__ + "static/media/Logotipo.9ba9e9e8.png";